import React, { useEffect, useRef } from "react";

import lenovo from "../assests/images/lenovo.png";
import hp from "../assests/images/hplogo.webp";
import dell from "../assests/images/dell.webp";
import acer from "../assests/images/acer.jpg";
import asus from "../assests/images/asus.png";

const laptopLogos = [lenovo, hp, dell, acer, asus];

export default function Partners() {
  const trackRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let position = 0;
    const speed = 1.7; // smooth speed

    const firstSetWidth = track.scrollWidth / 2;

    const animate = () => {
      position -= speed;

      // jab ek full set bahar chala jaye, usko peeche chipka do
      if (Math.abs(position) >= firstSetWidth) {
        position += firstSetWidth;
      }

      track.style.transform = `translateX(${position}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "hidden",
        // background: "#fff",
        padding: "20px 0",
      }}
    >
      <div
        ref={trackRef}
        style={{
          display: "flex",
          width: "max-content",
        }}
      >
        {[...laptopLogos, ...laptopLogos, ...laptopLogos].map((logo, index) => (
          <div
            key={index}
            style={{
            
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "40px",
            }}
          >
            <img
              src={logo}
              alt={`brand-${index}`}
              style={{
                maxHeight: "70px",
                maxWidth: "140px",
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
